<template>
  <section class="uc-onb-bar" :class="{ 'is-open': expanded }" aria-label="Онбординг">
    <div class="uc-onb-bar__icon" aria-hidden="true">
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12 3l7 3v5c0 4.5-3 8.2-7 10-4-1.8-7-5.5-7-10V6l7-3z" />
        <path d="M12 8v5" />
        <path d="M12 16.5h.01" />
      </svg>
    </div>

    <span class="uc-onb-bar__badge">Терміново</span>

    <p class="uc-onb-bar__text">
      <strong>Пройдіть онбординг</strong><span class="uc-onb-bar__text-tail"> — без нього недоступне оформлення полісів</span>
    </p>

    <div
      class="uc-onb-bar__progress"
      role="progressbar"
      aria-label="Прогрес онбордингу"
      aria-valuemin="0"
      :aria-valuemax="total"
      :aria-valuenow="completed"
    >
      <div class="uc-onb-bar__track">
        <div class="uc-onb-bar__fill" :style="{ width: progress + '%' }" />
      </div>
      <span class="uc-onb-bar__count">{{ completed }} з {{ total }}</span>
    </div>


    <button
      type="button"
      class="uc-onb-bar__toggle"
      :aria-expanded="expanded ? 'true' : 'false'"
      :aria-label="expanded ? 'Згорнути' : 'Відкрити повністю'"
      @click="expanded = !expanded"
    >
      <span class="uc-onb-bar__toggle-text">{{ expanded ? 'Згорнути' : 'Відкрити' }}</span>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M6 9l6 6 6-6" />
      </svg>
    </button>

    <SmartLink :route="{ name: 'onboardingPage' }" class="uc-onb-bar__btn">
      Пройти онбординг
      <span class="uc-onb-bar__circle" aria-hidden="true">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
          <path d="M6 6l6 6-6 6" />
          <path d="M12 6l6 6-6 6" />
        </svg>
      </span>
    </SmartLink>
  </section>
</template>

<script>
import { SmartLink } from '@/shared/ui/link';
export default {
  name: 'OnboardingBar',
  components: {
    SmartLink
  },
  data () {
    return {
      expanded: false
    }
  },
  props: {
    onboardingData: { type: Object, default: {} },
    // completed: { type: Number, default: 0 },
    total: { type: Number, default: 3 },
    to: { type: [String, Object], default: null },
    href: { type: String, default: '/onboarding' }
  },
  computed: {
    progress () {
      return this.total ? (this.completed / this.total) * 100 : 0
    },
    completed() {
      console.log('this.onboardingData', this.onboardingData)
      const step = this.onboardingData?.step ?? 0;
      let completed = 0;
      switch (step) {
        case 0:
        case 1:
        case 2:
        case 3:
          completed = 0;
          break;
        case 4:
        case 5:
          completed = 1;
          break;
        case 6:
        case 7:
        case 8:
          completed = 2;
          break;
        case 9:
          completed = this.onboardingData.status_id ? 3 : 2;
          break;
        default:
          completed = 0;
          break;
      }
      return completed;
      // return 3;
    },
  }
}
</script>

<style scoped>
.uc-onb-bar {
  --uc-red: #c93a2e;
  --uc-red-dark: #a3281f;
  --uc-red-tint: #fff2f0;
  --uc-red-track: #fbd9d4;
  --uc-ink: #373a3d;
  --uc-ink-soft: #494e53;

  display: flex;
  margin-bottom: 10px;
  align-items: center;
  gap: 16px;
  padding: 10px 10px 10px 12px;
  background: var(--uc-red-tint);
  /*border-radius: 16px;*/
  box-shadow: 0 2px 8px rgba(201, 58, 46, 0.1);
  /*box-shadow: 0 8px 32px rgba(201, 58, 46, 0.1);*/
  font-family: Inter, system-ui, sans-serif;
  color: var(--uc-ink);
}

.uc-onb-bar__icon {
  flex: 0 0 44px;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: var(--uc-red);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.uc-onb-bar__badge {
  flex: 0 0 auto;
  padding: 4px 10px;
  border-radius: 999px;
  background: var(--uc-red);
  color: #fff;
  font-size: 13px;
  line-height: 18px;
  font-weight: 600;
}

.uc-onb-bar__text {
  flex: 1 1 auto;
  min-width: 0;
  margin: 0;
  font-size: 16px;
  line-height: 22px;
  color: var(--uc-ink-soft);
}

.uc-onb-bar__text strong {
  font-family: 'IBM Plex Sans', system-ui, sans-serif;
  font-size: 17px;
  font-weight: 600;
  color: var(--uc-ink);
}

.uc-onb-bar__progress {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 10px;
}

.uc-onb-bar__track {
  width: 96px;
  height: 6px;
  border-radius: 999px;
  background: var(--uc-red-track);
  overflow: hidden;
}

.uc-onb-bar__fill {
  height: 100%;
  border-radius: 999px;
  background: var(--uc-red);
  transition: width 0.3s ease;
}

.uc-onb-bar__count {
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  color: var(--uc-red-dark);
  white-space: nowrap;
}

.uc-onb-bar__btn {
  flex: 0 0 auto;
  height: 44px;
  padding: 0 8px 0 20px;
  display: inline-flex;
  align-items: center;
  gap: 12px;
  border-radius: 12px;
  background: var(--uc-red);
  color: #fff;
  text-decoration: none;
  font-family: 'IBM Plex Sans', system-ui, sans-serif;
  font-size: 16px;
  line-height: 20px;
  font-weight: 600;
  white-space: nowrap;
  transition: background-color 0.15s ease;
}

.uc-onb-bar__btn:hover {
  background: var(--uc-red-dark);
  color: #fff;
}

.uc-onb-bar__btn:focus-visible {
  outline: 2px solid var(--uc-red);
  outline-offset: 2px;
}

.uc-onb-bar__circle {
  width: 28px;
  height: 28px;
  border-radius: 999px;
  background: #fff;
  color: var(--uc-red);
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 900px) {
  .uc-onb-bar {
    flex-wrap: wrap;
    margin-bottom: 12px;
    border-radius: 8px;
  }

  .uc-onb-bar__text {
    flex-basis: calc(100% - 180px);
  }
}

.uc-onb-bar__toggle {
  display: none;
}

@media (max-width: 640px) {
  .uc-onb-bar__badge {
    display: none;
  }

  .uc-onb-bar__btn {
    width: 100%;
    justify-content: space-between;
  }

  .uc-onb-bar__toggle {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    height: 32px;
    padding: 0 8px 0 10px;
    border: 1px solid var(--uc-red-track);
    border-radius: 8px;
    background: #fff;
    color: var(--uc-red-dark);
    font-family: inherit;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
  }

  .uc-onb-bar__toggle svg {
    transition: transform 0.2s ease;
  }

  .uc-onb-bar.is-open .uc-onb-bar__toggle {
    order: 2;
    margin-left: auto;
  }

  .uc-onb-bar.is-open .uc-onb-bar__toggle svg {
    transform: rotate(180deg);
  }

  .uc-onb-bar:not(.is-open) {
    flex-wrap: nowrap;
    gap: 10px;
    padding: 8px 8px 8px 10px;
  }

  .uc-onb-bar:not(.is-open) .uc-onb-bar__icon {
    flex-basis: 32px;
    width: 32px;
    height: 32px;
    border-radius: 9px;
  }

  .uc-onb-bar:not(.is-open) .uc-onb-bar__icon svg {
    width: 18px;
    height: 18px;
  }

  .uc-onb-bar:not(.is-open) .uc-onb-bar__text {
    flex-basis: auto;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .uc-onb-bar:not(.is-open) .uc-onb-bar__text strong {
    font-size: 15px;
  }

  .uc-onb-bar:not(.is-open) .uc-onb-bar__text-tail,
  .uc-onb-bar:not(.is-open) .uc-onb-bar__track,
  .uc-onb-bar:not(.is-open) .uc-onb-bar__btn {
    display: none;
  }

  .uc-onb-bar:not(.is-open) .uc-onb-bar__count {
    font-size: 13px;
  }

  .uc-onb-bar.is-open .uc-onb-bar__text {
    flex-basis: 100%;
    order: 3;
  }

  .uc-onb-bar.is-open .uc-onb-bar__progress {
    order: 4;
    flex-basis: 100%;
  }

  .uc-onb-bar.is-open .uc-onb-bar__track {
    flex: 1;
  }

  .uc-onb-bar.is-open .uc-onb-bar__btn {
    order: 5;
  }
}
</style>
